/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { call, put, select, takeLatest } from 'redux-saga/effects'
import { getServiceIdSelector } from '../../user/selectors'
import { setTempMethodOptions } from '../store/options.actions'
import { VitalsService } from '../../vitals/services/vitals.service'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { ITempMethodResponse } from '../../vitals/store/vitals.types'

export function* getTempMethod() {
  const serviceId = yield select(getServiceIdSelector)
  const vitalsService = new VitalsService(serviceId)
  try {
    const tempMethodResponse: ITempMethodResponse = yield call([vitalsService, vitalsService.getTempMethod])
    const { entity } = tempMethodResponse
    entity.sort((e1, e2) => e1.name.localeCompare(e2.name))
    yield put(setTempMethodOptions(entity))
  } catch (e) {
    yield put(throwPcrException(`getTempMethod() error: ${e}`))
  }
}

export function* getTempMethodSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getTempMethod)
}
